import { z } from 'zod';
import { getDashboardModalExtensionsDir } from '@wix/cli-astro-definitions';
import {
  VALID_PATH_REGEX,
  pathAvailableValidation,
} from '../../../dev-center/components/validations/common.js';
import type { ExtensionDef } from '../generate-schema/types.js';
import { defineField } from '../generate-schema/definitions.js';
import { generateDashboardModal } from './generate.js';

const schema = z.object({
  extensionType: z.literal('DASHBOARD_MODAL'),
  title: z.string().describe(defineField({ title: 'Modal title' })),
  folder: z
    .string()
    .regex(VALID_PATH_REGEX)
    .describe(
      defineField({
        title: 'Modal folder',
        description: 'Lowercase alphanumeric and hyphens only.',
      })
    ),
});

export const dashboardModal: ExtensionDef<typeof schema> = {
  title: 'Dashboard Modal',
  description: 'A Dashboard modal dialog',
  group: 'Dashboard',
  documentation:
    'https://dev.wix.com/docs/wix-cli/guides/extensions/dashboard-extensions/dashboard-modals/add-dashboard-modal-extensions',
  zodSchema: schema,
  validate: async (projectFolder, data) => {
    const isAvailable = pathAvailableValidation(
      getDashboardModalExtensionsDir(projectFolder)
    )(data.folder);
    return isAvailable
      ? null
      : 'The modal folder must be unique, please choose a folder that has not been used yet in your application.';
  },
  generate: ({ projectFolder, data }) =>
    generateDashboardModal(projectFolder, data.folder, data.title),
};
